import React from 'react';
import { AdminSectionTitle as SectionTitle } from '../AdminUI';

const AdminSectionTitle = ({ title, description }) => {
  return <SectionTitle title={title} description={description} />;
};

export default AdminSectionTitle;
